export const isXpad = () => {
  // 判断是否在xpad环境
  const ua = window.navigator.userAgent;
  if (/TALIH/i.test(ua)) {
    return true;
  }
  return false;
};
export const isStudentEnd = () => {
  return (
    window.XesInstance && (window.XesInstance.isMobileApp() || window.XesInstance.isWdFunction())
  );
}
